const DownIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='12'
		viewBox='0 0 12 12'
		width='12'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5.25 0V9.125L1.0625 4.9375L0 6L6 12L12 6L10.9375 4.9375L6.75 9.125V0H5.25Z'
			fill='currentColor'
		/>
	</svg>
)

export { DownIcon }
